import type { RouteObject } from 'react-router';

let registeredRoutes: RouteObject[] = [];

export const registerRoutes = (routes: RouteObject[]): void => {
  registeredRoutes = routes;
};

export const getRegisteredRoutes = (): RouteObject[] => registeredRoutes;
